import clsx from "clsx"
import { FC, memo } from "react"
import { useTranslation } from "react-i18next"
import styles from "./ActiveEffectRow.module.scss"
import { IActiveEffectRowProps } from "./types"

const ActiveEffectRowComponent: FC<IActiveEffectRowProps> = ({ effect }) => {
  const { t } = useTranslation(["hero", "inventory"])

  return (
    <li className={styles.ActiveEffectRow}>
      {effect.iconUrl ? (
        <img
          className={styles.ActiveEffectRow_icon}
          src={effect.iconUrl}
          alt=""
          loading="lazy"
        />
      ) : (
        <span className={styles.ActiveEffectRow_icon} />
      )}
      <div className={styles.ActiveEffectRow_body}>
        <span className={styles.ActiveEffectRow_name}>
          {t(effect.nameKey, { defaultValue: effect.effectCode })}
        </span>
        {effect.stats.map((stat) => (
          <span key={stat.statCode} className={styles.ActiveEffectRow_stat}>
            <span>
              {t(`catalog:stat.${stat.statCode}`, {
                defaultValue: stat.statCode
              })}
            </span>
            <span
              className={clsx(styles.ActiveEffectRow_statValue, {
                [styles.negative]: stat.isNegative
              })}
            >
              {stat.text}
              {stat.isPoints && ` ${t("hero:unit.points")}`}
            </span>
          </span>
        ))}
      </div>
      <div className={styles.ActiveEffectRow_remaining}>
        {effect.days !== null && (
          <span className={styles.ActiveEffectRow_days}>
            {t("hero:activeEffects.days", { count: effect.days })}
          </span>
        )}
        <span className={styles.ActiveEffectRow_clock}>{effect.clock}</span>
      </div>
    </li>
  )
}

export const ActiveEffectRow = memo(ActiveEffectRowComponent)
